// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"6a0cb245","436":"5f7b5096","458":"e80ecd15","571":"f297117b","686":"2c370843","759":"b36a9067","818":"6a7586e2"}[chunkId] + ".chunk.js";
};